import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Table } from 'react-bootstrap';
// import '../css/table.css';
import '../css/main.css';
export default class MaintenanceAuditCardsComponent extends React.Component {

    // constructor(props) {
    //     super(props);
    // }

    previousPage() {
        //MaintenanceAuditContainer
        hashHistory.push("/auditing");
    }

    componentDidMount() {
    }

    componentWillMount() {
        this.props.findAuditableMCards(this.props.request.get('target'));
    }

    assignAuditingPant(card) {
        this.props.assignAuditingPant(card);
        hashHistory.push("/auditingTarget");
    }

    assignAuditingClothes(card) {
        this.props.assignAuditingClothes(card);
        hashHistory.push("/auditingTarget");
    }

    viewPhotos(cardId) {
        this.props.findPhotos(cardId);
        this.props.changePhotoListPreviousPage('/auditingCards');
        hashHistory.push("/photoList");
    }

    render() {

        let cardStatus = function (statusKey) {
            switch (statusKey) {
                case 'FIXING':
                    return '可部分檢點';

                case 'FIXED':
                    return '可檢點';

                case 'AUDITED':
                    return '檢點完成';

                default:
                    return "";
            }
        }

        let highlight = function (statusKey) {
            switch (statusKey) {
                case 'FIXING':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFE8BF",
                    };
                case 'FIXED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",
                    };
                case 'AUDITED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#96FF96",
                    };
                default:
                    return {};
            }
        }

        let highlightClassName = function (statusKey) {
            switch (statusKey) {
                case 'FIXING':
                    return "highlight-brown";
                case 'FIXED':
                    return "highlight-red";
                case 'AUDITED':
                    return "highlight-green";
                default:
                    return '';
            }
        }

        let sortIcon = (field) => {
            let orders = this.props.request.get('sortOrders');
            let asc = orders.get(field).get('asc');
            let icon;
            if (asc === undefined || orders.get('orderby') !== field) {
                icon = 'sort.svg';
            } else {
                icon = asc ? 'sort-up.svg' : 'sort-dw.svg';
            }

            return <a
                onClick={(event) => {
                    this.props.sortCards(
                        this.props.response.get('cards'),
                        this.props.request.get('sortOrders').get(field));
                }
                }>
                <img src={icon} height="18" width="18" className='sort' alt="" />
            </a>
        }

        let alignCenter = {
            textAlign: "center",
            verticalAlign: "middle"
        }

        let disabledClothBtn = (card) => {
            return card.noClothes || card.discardClothes;
        }
        let disabledPantBtn = (card) => {
            return card.noPant || card.discardPant;
        }

        let clothBtnDesc = (card) => {
            let cloth = "";
            if (card.noClothes) {
                return cloth + "未送修";
            }
            if (card.discardClothes) {
                return cloth + "不需維修";
            }
            if (card.clothesAudited) {
                return cloth + "明細";
            }
            return "檢點";
        }
        let pantBtnDesc = (card) => {
            let cloth = "";
            if (card.noPant) {
                return cloth + "未送修";
            }
            if (card.discardPant) {
                return cloth + "不需維修";
            }
            if (card.pantAudited) {
                return cloth + "明細";
            }
            return "檢點";
        }

        let clothAudited = (card) => {
            if (card.noClothes || card.discardClothes) return "default";

            if (card.clothesAudited) {
                return "success"
            } else {
                return "warning"
            }
        }

        let pantAudited = (card) => {
            if (card.noPant || card.discardPant) return "default";
            if (card.pantAudited) {
                return "success"
            } else {
                return "warning"
            }
        }
        
        return (
            <div>
                <h4>
                    檢點作業&nbsp;&gt;&gt;&nbsp;維修卡&nbsp;
                    <a onClick={(e) => { this.previousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
                </h4>
                <span hidden>MaintenanceAuditCardsComponent </span>
                <table className="main">
                    <tbody>
                        <tr>
                            <th width="14%">訂單編號</th>
                            <td width="22%" className={"highlight"} style={{ textAlign: "center" }}>{this.props.request.get("mcase").orderId} {this.props.request.get("mcase").note}</td>
                            <th width="14%">客戶名稱</th>
                            <td width="22%">{this.props.request.get("mcase").customer.customerName}</td>
                            <th width="14%">建立時間</th>
                            <td width="14%">{new Date(this.props.request.get("mcase").createTime).toLocaleDateString()}</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th>序號  {sortIcon("code")}</th>
                            <th>單位 {sortIcon("unit")}</th>
                            <th>使用者  {sortIcon("owner")}</th>
                            <th>消防衣(檢點)  {sortIcon("status")}</th>
                            <th>消防褲(檢點)  {sortIcon("status")}</th>
                            <th>狀態  {sortIcon("status")}</th>
                            <th>相片</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.props.response.get('cards').map(
                                (item, index) =>
                                    <tr key={index}>
                                        <td>{item.code}</td>
                                        <td>{item.organization} - {item.unit}</td>
                                        <td>{item.owner}</td>
                                        <td>
                                            <Button bsStyle={clothAudited(item)}
                                                disabled={disabledClothBtn(item)}
                                                onClick={(event) => {
                                                    this.assignAuditingClothes(item);
                                                }}
                                            >
                                                <img alt='shirt' src='shirt.svg' height="25" width="25" /> {clothBtnDesc(item)}
                                            </Button>

                                        </td>
                                        <td>
                                            <Button bsStyle={pantAudited(item)}
                                                disabled={disabledPantBtn(item)}
                                                onClick={(event) => {
                                                    this.assignAuditingPant(item);
                                                }}
                                            >
                                                <img alt='shorts' src='shorts.svg' height="25" width="25" /> {pantBtnDesc(item)}
                                            </Button>

                                        </td>
                                        <td style={highlight(item.status)} className={highlightClassName(item.status)}>{cardStatus(item.status)}</td>
                                        <td style={alignCenter}>
											<Button onClick={(e) => { this.viewPhotos(item.id); }} >
												<img title="photos" alt='photos' src='gallery.svg' height="22" width="24" />
											</Button>
										</td>
                                    </tr>
                            )
                        }
                    </tbody>
                </Table>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceAuditCardsComponent.jsx